import { render, staticRenderFns } from "./ProductAdditionalFields.vue?vue&type=template&id=871ee33e&scoped=true&lang=pug&"
import script from "./ProductAdditionalFields.vue?vue&type=script&lang=ts&"
export * from "./ProductAdditionalFields.vue?vue&type=script&lang=ts&"
import style0 from "./ProductAdditionalFields.vue?vue&type=style&index=0&id=871ee33e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871ee33e",
  null
  
)

export default component.exports